// src/util/auth.js
import firebase from './firebase';

// GUARD => Wenn kein Token im Storage, weiterleiten zu Login
export const authMiddleWare = (history) => {
  const authToken = localStorage.getItem('AuthToken');
  if (!authToken) {
    history.push('/login');
  }
};

// Token manuell verlängern (Session verlängert sich so)
export const refreshAuthToken = async () => {
  const user = firebase.auth().currentUser;

  if (!user) {
    console.warn("Kein Firebase User, kann Token nicht erneuern.");
    return null;
  }

  // Force Refresh = hole IMMER neues ID-Token
  const token = await user.getIdToken(true);

  const authToken = `Bearer ${token}`;
  localStorage.setItem('AuthToken', authToken);

  return authToken;
};
